import type { VisualizationType } from '@tempo-io/roadmap-dto';

const LOOP_VIEW_VISUALIZATION_KEY = 'nexus_loop_view_last_visited_visualization';
const LOOP_VIEW_KEY = 'nexus_loop_last_visited_view';

type VisualizationStorage = Partial<Record<number, VisualizationType>>;
type ViewStorage = Partial<Record<number, number>>;

function read<T>(key: string): T extends object ? T : never {
  try {
    const raw = window.localStorage.getItem(key);
    return (raw ? JSON.parse(raw) : {}) as T extends object ? T : never;
  } catch {
    return {} as T extends object ? T : never;
  }
}

function write(key: string, data: object): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // localStorage disabled or quota exceeded — silently ignore
  }
}

export function getLastVisitedVisualization(viewId: number): VisualizationType | undefined {
  if (typeof window === 'undefined') return undefined;
  return read<VisualizationStorage>(LOOP_VIEW_VISUALIZATION_KEY)[viewId];
}

export function saveLastVisitedVisualization(viewId: number, type: VisualizationType): void {
  if (typeof window === 'undefined') return;
  write(LOOP_VIEW_VISUALIZATION_KEY, {
    ...read<VisualizationStorage>(LOOP_VIEW_VISUALIZATION_KEY),
    [viewId]: type,
  });
}

export function getLastVisitedView(roadmapId: number): number | undefined {
  if (typeof window === 'undefined') return undefined;
  return read<ViewStorage>(LOOP_VIEW_KEY)[roadmapId];
}

export function saveLastVisitedView(roadmapId: number, viewId: number): void {
  if (typeof window === 'undefined') return;
  write(LOOP_VIEW_KEY, { ...read<ViewStorage>(LOOP_VIEW_KEY), [roadmapId]: viewId });
}
